export default function cleanFilename(filename) {
  // split into name + extension
  const dotIndex = filename.lastIndexOf('.');
  const ext = dotIndex !== -1 ? filename.slice(dotIndex).toLowerCase() : '';
  let name = dotIndex !== -1 ? filename.slice(0, dotIndex) : filename;


name = name.replace(/%5B/gi, '(')
    .replace(/%5D/gi, ')')
    .replace(/[()]/g, '')               // remove parentheses
    .replace(/\d+/g, '')                // remove ALL numbers
    .replace(/[^a-zA-Z-_ ]+/g, '')      // remove weird symbols except dash/underscore
    .replace(/\s+/g, '-')               // spaces → dashes
    .replace(/-+/g, ' ')                // collapse multiple ---- (original function replaces with '-')
    .replace(/_+/g, ' ')                // collapse multiple ____ (original function replaces with '_')
    .replace(/[-_]+$/g, '')             // trim trailing separators
    .replace(/^[-_]+/g, '')             // trim leading separators
    .trim()

  return name + ext;
}
